import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Dehumidifier Icon Style 02 - Humidity Percentage (Material Symbol)
 */
export const Style02_Humidity: React.FC<DeviceIconProps> = ({
  isOn = false,
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-cyan-500' : 'text-slate-400';

  return (
    <span
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' ${isOn ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      humidity_percentage
    </span>
  );
};

export default Style02_Humidity;
